import { axiosInstance, overrideHeader } from '.';
import { getItem } from '../utils/cache';

export const addToCartRequest = product_id => {
  const data = {
    product_id,
  };
  overrideHeader();
  return axiosInstance.post('/carts/add', data);
};

export const removeToCartRequest = product_id => {
  const body = {
    data: {
      product_id,
    },
  };
  overrideHeader();
  return axiosInstance.delete('/carts/remove', body);
};

export const getCartInfoRequest = () => {
  overrideHeader();
  return axiosInstance.get('/carts/show');
};

export const getCartInfoRequest2 = () => {
  let products = [];
  const OfflineCartData = JSON.parse(getItem('offlineCart'));
  if (OfflineCartData?.length) {
    products = OfflineCartData.map(
      item => item?.attributes?.product_id || item?.id,
    );
  }

  const body = {
    selected_product_ids: products,
  };
  overrideHeader();
  return axiosInstance.post('/carts/public_show', body);
};

export const createOrderRequest = params => {
  overrideHeader();
  return axiosInstance.post('/orders', undefined, {
    params,
  });
};

export const getOrderDetailsRequest = id => {
  overrideHeader();
  return axiosInstance.get('/orders/' + id);
};
